// extracted by mini-css-extract-plugin
module.exports = {"navButton":"Controls_navButton__3zI-i"};